var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "27"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M8.406.536.48 14.43H7.3L3.54 26.887l11.98-16.436H7.668L14.525.536z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }